import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Addmoney from "./Addmoney";
import Wallettransaction from './Wallettransaction';
import Thankyou from './Thankyou'


export default function wallet() {
  return (
    <Switch>
     

      {/* Layout */}
      <Route path="/wallet/addmoney" component={Addmoney} />
      <Route path='/wallet/transaction' component={Wallettransaction} />
      <Route path='/wallet/thankyou' component={Thankyou} />
     
    </Switch>
  );
}
